import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditcardDollar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.a{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M2.5,7.6h19"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M7,16.75H4.5a2,2,0,0,1-2-2v-9a2,2,0,0,1,2-2h15a2,2,0,0,1,2,2v9a2,2,0,0,1-2,2H17"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,21.75a5,5,0,1,0-5-5,5.029,5.029,0,0,0,5,5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,14.5v-.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,19v.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M10.7,18.464a1.081,1.081,0,0,0,.927.538h.822a1.053,1.053,0,0,0,.256-2.075L11.3,16.574a1.053,1.053,0,0,1,.256-2.075h.822a1.08,1.08,0,0,1,.925.536"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M0,0H24V24H0Z"
		})
	]
});
export default SvgCreditcardDollar;
